import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content']
  static values = { url: String }

  connect() {
    if (this.urlValue) {
      this.refresh()
    }
  }

  refresh() {
    this.contentTarget.innerHTML = `
      <div class="flex items-center justify-center py-8 text-base-content/50">
        <span class="loading loading-spinner loading-sm mr-2"></span> Loading resource usage...
      </div>
    `

    fetch(this.urlValue, {
      headers: { 'Accept': 'application/json' }
    })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.json()
      })
      .then(data => this.renderUsage(data))
      .catch(error => this.renderError(error.message))
  }

  renderUsage(data) {
    if (data.error) {
      this.renderError(data.error)
      return
    }

    const cpu = data.cpu || {}
    const memory = data.memory || {}
    const disk = data.disk || {}
    const uptime = data.uptime || {}
    const load = data.load_average || {}

    const memUsed = memory.used_mb ? `${(memory.used_mb / 1024).toFixed(1)} GB` : 'N/A'
    const memTotal = memory.total_mb ? `${(memory.total_mb / 1024).toFixed(1)} GB` : 'N/A'

    this.contentTarget.innerHTML = `
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <div>
          <div class="flex justify-between text-sm mb-1">
            <span class="text-base-content/60">CPU</span>
            <span class="font-mono">${cpu.usage_percent ?? 'N/A'}%</span>
          </div>
          <progress class="progress progress-primary w-full" value="${cpu.usage_percent || 0}" max="100"></progress>
        </div>

        <div>
          <div class="flex justify-between text-sm mb-1">
            <span class="text-base-content/60">Memory</span>
            <span class="font-mono">${memUsed} / ${memTotal}</span>
          </div>
          <progress class="progress progress-secondary w-full" value="${memory.usage_percent || 0}" max="100"></progress>
        </div>

        <div>
          <div class="flex justify-between text-sm mb-1">
            <span class="text-base-content/60">Disk</span>
            <span class="font-mono">${disk.used || 'N/A'} / ${disk.total || 'N/A'}</span>
          </div>
          <progress class="progress progress-accent w-full" value="${disk.usage_percent || 0}" max="100"></progress>
        </div>
      </div>

      <div class="flex flex-wrap gap-6 mt-4 text-sm text-base-content/70">
        <div>
          <span class="text-base-content/50">Uptime:</span>
          <span class="font-mono">${uptime.pretty || 'N/A'}</span>
        </div>
        <div>
          <span class="text-base-content/50">Load:</span>
          <span class="font-mono">${load.one_min ?? 'N/A'}, ${load.five_min ?? 'N/A'}, ${load.fifteen_min ?? 'N/A'}</span>
        </div>
      </div>
    `
  }

  renderError(message) {
    this.contentTarget.innerHTML = `
      <div class="text-center py-8 text-base-content/50">
        <i class="fas fa-exclamation-triangle mr-2"></i>
        Unable to fetch resource usage: ${message}
      </div>
    `
  }
}
